import { Operator } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'
import { notifyError } from '@/utils/notifyError'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (
  args: FetchApiArgs<{ operatorId: number }, string, string>
): Promise<FetchApiResponse<Operator>> => {
  const {
    signal,
    additionalParams: { operatorId }
  } = args

  const { data } = await ddeApi.endpoints.operators.getOperator(operatorId, signal)

  if (Array.isArray(data) && data.length > 0) {
    try {
      const { data: mediaFeed } = await ddeApi.endpoints.operators.getDelay(operatorId, signal)
      data[0].delay = mediaFeed?.delay || 5
    } catch (err: unknown) {
      const error = err as { status?: number; message?: string }

      if (error?.status === 404) {
        data[0].delay = 5 // Default delay if not set for all operators. See Slack 🧵: https://imgarena.slack.com/archives/CSL9J2NCQ/p1757071797233299
      } else {
        notifyError(`Failed to get media feed delay: ${error?.message || 'Unknown error'}`)
      }
    }
  }

  return {
    content: data,
    totalElements: data.length
  }
}

export const useOperatorStoreDDE = createBaseTableStore({
  storeName: 'DDE Operator',
  fetchApi
})
